<template>
  <article
    class="relative max-w-sm bg-transparent rounded-xl dark:bg-gray-800 dark:border-gray-700 mt-16"
  >
    <div class="w-full flex justify-center absolute -top-16">
      <div class="size-32 mb-3 rounded-full bg-zinc-300" />
    </div>
    <section class="p-5 pt-20 bg-cardBg rounded-t-xl space-y-2">
      <div class="bg-zinc-200 w-32 h-6 rounded-full mx-auto"></div>
      <div class="bg-zinc-100 w-56 h-2 rounded-full"></div>
      <div class="bg-zinc-100 w-56 h-2 rounded-full"></div>
      <div class="bg-zinc-100 w-56 h-2 rounded-full"></div>
      <div class="bg-zinc-100 w-56 h-2 rounded-full"></div>
    </section>
    <div class="bg-cardBg p-5 flex justify-center rounded-b-xl">
      <div class="bg-zinc-400 w-56 h-9 rounded-md"></div>
    </div>
  </article>
</template>
